import PersonasArchivosConsulta from './PersonasArchivosConsulta';

export default PersonasArchivosConsulta;
